import * as v from "valibot";
import { rpcContract } from "../rpc";

export const requestLiveEventAccessRpcContract = rpcContract({
  name: "request-live-event-access",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    status: v.picklist(["pending", "approved", "rejected"]),
  }),
});

export type RequestLiveEventAccessParams = v.InferOutput<(typeof requestLiveEventAccessRpcContract)["paramsSchema"]>;
export type RequestLiveEventAccessResult = v.InferOutput<(typeof requestLiveEventAccessRpcContract)["resultSchema"]>;

export const getLiveEventAccessRequestRpcContract = rpcContract({
  name: "get-live-event-access-request",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    status: v.nullable(v.picklist(["pending", "approved", "rejected"])),
  }),
});

export type GetLiveEventAccessRequestParams = v.InferOutput<
  (typeof getLiveEventAccessRequestRpcContract)["paramsSchema"]
>;
export type GetLiveEventAccessRequestResult = v.InferOutput<
  (typeof getLiveEventAccessRequestRpcContract)["resultSchema"]
>;
